import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  select(event) {
    this.activate(this.tabTargets.indexOf(event.currentTarget))
  }

  navigate(event) {
    const keys = ["ArrowLeft", "ArrowRight", "Home", "End"]
    if (!keys.includes(event.key)) return

    event.preventDefault()
    const current = this.tabTargets.indexOf(event.currentTarget)
    let next = current
    if (event.key === "ArrowLeft") next = (current - 1 + this.tabTargets.length) % this.tabTargets.length
    if (event.key === "ArrowRight") next = (current + 1) % this.tabTargets.length
    if (event.key === "Home") next = 0
    if (event.key === "End") next = this.tabTargets.length - 1
    this.activate(next)
    this.tabTargets[next].focus()
  }

  reveal(event) {
    if (!this.hasTabTarget) return

    const index = this.panelTargets.findIndex(panel => panel.contains(event.target))
    if (index >= 0) this.activate(index)
  }

  activate(index) {
    this.tabTargets.forEach((tab, position) => {
      const selected = position === index
      tab.classList.toggle("active", selected)
      tab.setAttribute("aria-selected", String(selected))
      tab.tabIndex = selected ? 0 : -1
      this.panelTargets[position].hidden = !selected
    })
  }
}
